import querystring from 'querystring'

export default function makeAuthenticate ({ authStore }) {
  return async function authenticate (nextState, replace, callback) {
    let hash = nextState.location.hash
    if (hash) {
      const parsed = querystring.parse(hash.substring(1))
      if (parsed && parsed.access_token) {
        window.location.hash = ''
        authStore.setToken(parsed.access_token)
      }
    }

    if (!await authStore.checkAuthentication()) {
      replace({
        pathname: '/login',
        state: { nextPathname: nextState.location.pathname }
      })
    }

    callback()
  }
}



// WEBPACK FOOTER //
// ./src/client/shell/AppRouter/interceptors/authenticate.js